import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'pt-5',
    title: 'heading-2xl-desk max-sm:heading-2xl',
    description: 'heading-m mt-4',
    button: 'mt-10 w-[320px]',
    products: 'bg-bg-items-white mt-12 px-5 py-6 md:p-10',
    productsTitle: 'heading-xl mb-6',
    productsList: 'flex flex-col gap-3'
  }
});
